// src/top/Top.jsx
// ログイン不要で表示できるページ
import React from 'react';
import { Link } from 'react-router-dom';
import useAuthStore from '../stores/authStore';
import EnduserEventList from '../enduser/eventlist';
import './Top.css';

const Top = () => {
  const { accessToken } = useAuthStore();

  return (
    <div className="top-page">
      <header className="top-hero">
        <div className="top-hero-inner">
          <div className="top-hero-bar">
            <span className="top-brand">DOG SHOW CATALOGUE</span>
            {accessToken ? (
              <Link to="/" className="top-link">ホームへ</Link>
            ) : (
              <Link to="/login" className="top-link">ログイン</Link>
            )}
          </div>
          <p className="top-lead">
            全国のドッグショーの出陳犬・審査リング・開始時間をご確認いただけます。
          </p>
        </div>
      </header>

      <main className="top-main">
        <EnduserEventList />
      </main>
    </div>
  );
};

export default Top;
